import { getAuthHeaders, authedFetch } from './authService';
const HOSTNAME = process.env.REACT_APP_API_HOSTNAME ?? 'http://localhost:8000';

export type MetadataItem = {
  id: number;
  key: string;
  label: string;
  value: string;
  is_active: boolean;
};

export async function getMetadata(key?: string, isActive?: boolean): Promise<MetadataItem[]> {
  const params = new URLSearchParams();
  if (key) params.append('key', key);
  if (typeof isActive === 'boolean') params.append('is_active', String(isActive));
  const q = params.toString();
  const url = `${HOSTNAME}/adminportal/metadata${q ? `?${q}` : ''}`;
  const res = await authedFetch(url, { method: 'GET', headers: { ...getAuthHeaders() } });
  if (!res.ok) throw new Error(`Failed to fetch metadata: ${res.status}`);
  const body = await res.json();
  return body?.data?.metadata ?? body?.metadata ?? [];
}
